import { render, staticRenderFns } from "./NoticeOfPrivacy.vue?vue&type=template&id=332939e1&scoped=true&"
import script from "./NoticeOfPrivacy.vue?vue&type=script&lang=ts&"
export * from "./NoticeOfPrivacy.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeOfPrivacy.vue?vue&type=style&index=0&id=332939e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332939e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VRow})
